export const isMobileIos = userAgent => /iPhone|iPod/.test(userAgent) && !window.MSStream;
export const isMobileAndroid = userAgent =>
  /(android.+mobile)/i.test(userAgent) && !window.MSStream;

export const getDeviceType = userAgent => {
  if (isMobileIos(userAgent)) {
    return 'iOS Mobile';
  }

  if (isMobileAndroid(userAgent)) {
    return 'Android Mobile';
  }

  return 'Desktop/Other';
};

const getDeviceData = initialUserAgent => ({
  initialDevice: getDeviceType(initialUserAgent),
  lastDevice: getDeviceType(global.window.navigator.userAgent),
});

export default getDeviceData;
